import { TTeam } from './isTeam';

function teamName<TGenericTeam>(
	team?: (TGenericTeam & Pick<TTeam, 'name'>) | null
): string {
	return team?.name || '-';
}

export default teamName;
